import { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Timbratura from './pages/Timbratura';
import GestioneUtenti from './pages/GestioneUtenti';
import Storico from './pages/Storico';
import Presenze from './pages/Presenze';
import ReportMensile from './pages/ReportMensile';

function BottomNav({ tab, setTab, isAdmin }) {
  const items = [
    { id: 'dashboard', icon: '⊞', label: 'Home' },
    { id: 'timbratura', icon: '◎', label: 'Timbra' },
    { id: 'storico', icon: '📋', label: 'Storico' },
    ...(isAdmin ? [
      { id: 'presenze', icon: '📊', label: 'Presenze' },
      { id: 'report', icon: '📈', label: 'Report' },
      { id: 'utenti', icon: '👥', label: 'Utenti' },
    ] : []),
    { id: 'profilo', icon: '◉', label: 'Profilo' },
  ];
  return (
    <nav style={{ position: 'fixed', bottom: 0, left: 0, right: 0, maxWidth: 430, margin: '0 auto', background: '#0f172a', borderTop: '1px solid #1e293b', display: 'flex', zIndex: 100 }}>
      {items.map(i => (
        <button key={i.id} onClick={() => setTab(i.id)}
          style={{ flex: 1, padding: '10px 4px 8px', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
          <span style={{ fontSize: 18, filter: tab === i.id ? 'none' : 'grayscale(1) opacity(0.4)' }}>{i.icon}</span>
          <span style={{ fontSize: 9, fontWeight: 600, color: tab === i.id ? '#f59e0b' : '#475569', letterSpacing: '0.05em' }}>{i.label}</span>
        </button>
      ))}
    </nav>
  );
}

function Profilo() {
  const { utente, logout } = useAuth();
  return (
    <div style={{ padding: '24px 16px', paddingBottom: 90 }}>
      <h2 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 800, marginBottom: 24 }}>Profilo</h2>
      <div style={{ background: '#1e293b', borderRadius: 20, padding: 24, border: '1px solid #334155', textAlign: 'center', marginBottom: 20 }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', background: '#f59e0b22', border: '2px solid #f59e0b', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700, color: '#f59e0b' }}>
          {utente?.nome?.[0]}{utente?.cognome?.[0]}
        </div>
        <h3 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 800, margin: '0 0 4px' }}>{utente?.nome} {utente?.cognome}</h3>
        <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 12px' }}>{utente?.email}</p>
        <span style={{ background: '#f59e0b22', color: '#f59e0b', border: '1px solid #f59e0b44', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 700 }}>{utente?.ruolo}</span>
      </div>
      <div style={{ background: '#1e293b', borderRadius: 16, padding: '8px 16px', border: '1px solid #334155', marginBottom: 20 }}>
        {[
          ['🏢 Sede', utente?.sede],
          ['🔧 Reparto', utente?.reparto],
          ['📧 Email', utente?.email],
          ['📱 Telefono', utente?.telefono || '—']
        ].map(([k, v]) => (
          <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '11px 0', borderBottom: '1px solid #0f172a' }}>
            <span style={{ color: '#64748b', fontSize: 14 }}>{k}</span>
            <span style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 600 }}>{v}</span>
          </div>
        ))}
      </div>
      <button onClick={logout}
        style={{ width: '100%', padding: 14, background: '#0f172a', border: '1px solid #ef4444', borderRadius: 12, color: '#ef4444', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}>
        Esci dall'account
      </button>
    </div>
  );
}

function AppInner() {
  const { utente, loading } = useAuth();
  const [tab, setTab] = useState('dashboard');
  const isAdmin = utente?.ruolo === 'admin' || utente?.ruolo === 'responsabile';

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: '#f59e0b', fontSize: 18, fontWeight: 700 }}>Nerosicilia HR...</p>
    </div>
  );

  if (!utente) return <Login />;

  return (
    <div style={{ maxWidth: 430, margin: '0 auto', minHeight: '100vh', background: '#0f172a' }}>
      <div style={{ height: 'calc(100vh - 60px)', overflowY: 'auto' }}>
        {tab === 'dashboard' && <Dashboard onTimbratura={() => setTab('timbratura')} />}
        {tab === 'timbratura' && <Timbratura />}
        {tab === 'storico' && <Storico />}
        {tab === 'presenze' && isAdmin && <Presenze />}
        {tab === 'report' && isAdmin && <ReportMensile />}
        {tab === 'utenti' && isAdmin && <GestioneUtenti />}
        {tab === 'profilo' && <Profilo />}
      </div>
      <BottomNav tab={tab} setTab={setTab} isAdmin={isAdmin} />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
